// Copyright 2025. WebPros International GmbH. All rights reserved.

export const APPEND_SSH_KEY_ITEM = 'account/APPEND_SSH_KEY_ITEM';
export const SET_SSH_KEY_LIST = 'account/SET_SSH_KEY_LIST';
export const REMOVE_SSH_KEY_ITEM = 'account/REMOVE_SSH_KEY_ITEM';

export const SET_IS_LOADING = 'account/SET_IS_LOADING';
export const UNSET_IS_LOADING = 'account/UNSET_IS_LOADING';
